import { render, staticRenderFns } from "./CityCategoryList.vue?vue&type=template&id=1c170090"
import script from "./CityCategoryList.vue?vue&type=script&lang=ts"
export * from "./CityCategoryList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports